import Stake from "./stake";

export default Stake